import { render } from "./Products.vue?vue&type=template&id=65a1fe62"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"

import "./Products.vue?vue&type=style&index=0&id=65a1fe62&lang=scss"

import exportComponent from "D:\\Projects\\Normann\\Configurator Dashboard\\normann-dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__